/**
 *
 * DESCRIPTION : boolean 상태 관리 훅
 *
 */
import { useCallback, useEffect, useState } from 'react';

export default function useToggle(initValue = false) {
  const [visible, setVisible] = useState(initValue);

  useEffect(() => {
    const cleanup = () => {
      setVisible(initValue);
    };
    return () => cleanup();
  }, []);

  const handleVisible = useCallback(() => setVisible((prev) => !prev), []);

  return [visible, handleVisible] as const;
}
